import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import RowActions from 'components/RowActions';
import { rowActions as TEXT } from 'locales/en/integration';

const IntegrationActions = ({ isOpen, onClickOpen, onClose, id, position }) => {
  const renderItems = () => {
    const className =
      'block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer';

    const viewItem = <span className={className}>{TEXT.view}</span>;
    const editItem = <span className={className}>{TEXT.edit}</span>;
    const deleteItem = <span className={className}>{TEXT.delete}</span>;
    let options = [viewItem, editItem, deleteItem];

    return options.map((item, idx) => <Fragment key={idx}>{item}</Fragment>);
  };

  return (
    <RowActions
      onClickOpen={onClickOpen}
      isOpen={isOpen}
      onClose={onClose}
      position={position}
    >
      {renderItems()}
    </RowActions>
  );
};

IntegrationActions.propTypes = {
  onClickOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['top', 'bottom']),
  id: PropTypes.number,
};
IntegrationActions.defaultProps = {
  position: 'bottom',
};

export default memo(IntegrationActions);
